import React, { useRef } from 'react';
import clsx from 'clsx';

import { useTooltip } from '../toolbar/tooltip/Tooltip';

export const ToolbarButton = ({
  id,
  icon,
  className,
  active,
  name,
  children,
  ...buttonProps
}) => {
  const ref = useRef();
  const {
    setCurrentTitle,
    setAnchor,
  } = useTooltip();

  const updateTooltip = (value, anchor) => {
    setCurrentTitle(value);
    setAnchor(anchor);
  };

  const resetTooltip = () => {
    setCurrentTitle(null);
    setAnchor(null);
  };

  return (
    <button
      ref={ref}
      type="button"
      className={clsx(
        'button--unstyled',
        'plate-toolbar__button',
        active && 'plate-toolbar__button--active',
        className,
      )}
      onMouseDown={(e) => e.preventDefault()}
      onMouseEnter={() => updateTooltip(name, ref.current)}
      onMouseMove={() => updateTooltip(name, ref.current)}
      onMouseLeave={resetTooltip}
      {...buttonProps}
    >
      {children ?? icon}
    </button>
  );
};
